export const keyEnterPressed = (event) => {
  return event.key === 'Enter'
}
